export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";